import * as Msal from "@azure/msal-browser";
import {
  msalConfig,
  loginRequest,
  clientScope,
  epdpApiScope,
} from "@/client/msal.config";
import { mapToData } from "@/client/transformers";
import { Observable } from "rxjs";
import UserHeader from "@/models/user-header";

export class AuthService {
  public static msalInstance: Msal.PublicClientApplication =
    new Msal.PublicClientApplication(msalConfig);

  static isBrowser(): boolean {
    return typeof window !== "undefined" && typeof window.document !== "undefined";
  }
    
  static isWindowsHost(): boolean {
    if (!this.isBrowser()) return false;
    // This checks the browser’s platform
    return navigator?.platform?.toLowerCase().includes("win");
  }

  public static async login(): Promise<Msal.AuthenticationResult | void> {
    // AuthService.handleRedirectCallback();

    // return await AuthService.msalInstance
    //   .loginRedirect(loginRequest)
    //   .catch((err) => {
    //     console.error(err);
    //   });

    // return await AuthService.msalInstance
    //   .loginPopup(loginRequest)
    //   .then((res) => {
    //     if (res) {
    //       const accounts = this.msalInstance.getAllAccounts();
    //       console.log("accounts", accounts);
    //       if (accounts.length >= 1) {
    //         this.msalInstance.setActiveAccount(res.account);
    //       }
    //     }
    //     return res;
    //   })
    //   .catch(async (error) => {
    //     console.log("loginPopup error", error.errorCode, { error });
    //     if (error instanceof Msal.InteractionRequiredAuthError) {
    //       return await AuthService.msalInstance
    //         .loginRedirect(loginRequest)
    //         .catch((err) => {
    //           console.log("loginRedirect error", error.errorCode, { error });
    //           console.error(err);
    //         });
    //     }
    //   });

    await AuthService.msalInstance.loginRedirect(loginRequest).catch((err) => {
      console.log("loginRedirect error", err.errorCode, { err });
      console.error(err);
    });
  }

  public static async handleRedirectCallback(): Promise<Msal.AuthenticationResult | null | void> {
    return await AuthService.msalInstance
      .handleRedirectPromise()
      .then((res) => {
        console.log("handleRedirectCallback_response", res);
        if (res) {
          const accounts = this.msalInstance.getAllAccounts();
          console.log("accounts", accounts);
          if (accounts.length >= 1) {
            this.msalInstance.setActiveAccount(res.account);
          }
        }
        return res;
      })
      .catch((error) => {
        console.error("handleRedirectCallback_error", error);
      });
  }

  public static async acquireTokenGraph(): Promise<Msal.AuthenticationResult | void> {
    return await AuthService.acquireToken(loginRequest);
  }

  public static async acquireTokenClient(): Promise<Msal.AuthenticationResult | void> {
    return await AuthService.acquireToken(clientScope);
  }

  public static async acquireTokenEpdpApi(): Promise<Msal.AuthenticationResult | void> {
    return await AuthService.acquireToken(epdpApiScope);
  }

  private static async acquireToken(
    request: Msal.SilentRequest | Msal.PopupRequest | Msal.RedirectRequest
  ): Promise<Msal.AuthenticationResult | void> {
    return AuthService.msalInstance
      .acquireTokenSilent(request)
      .then((token) => {
        // console.log("Token silent", token);
        return token;
      })
      .catch(async (error) => {
        if (error instanceof Msal.InteractionRequiredAuthError) {
          return await AuthService.msalInstance.acquireTokenRedirect(request);
        }

        // console.log("Token silent error", error.errorCode, { error });
        // if (error instanceof Msal.InteractionRequiredAuthError) {
        //   return AuthService.msalInstance
        //     .acquireTokenPopup(request)
        //     .then((token) => {
        //       console.log("Token popup", token);
        //       return token;
        //     })
        //     .catch(async (err) => {
        //       console.log("Token popup error", err.errorCode, { err });
        //       if (
        //         err instanceof Msal.InteractionRequiredAuthError ||
        //         err instanceof Msal.BrowserAuthError
        //       ) {
        //         console.log("Call Redirect");
        //         return await AuthService.msalInstance.acquireTokenRedirect(
        //           request
        //         );
        //       }
        //     });
        // }
      });
  }

  public static async logout(): Promise<
    Msal.EndSessionPopupRequest | Msal.EndSessionRequest | void
  > {
    // return await AuthService.msalInstance.logoutRedirect();

    return await AuthService.msalInstance.logoutPopup().catch(async (error) => {
      if (
        error instanceof Msal.InteractionRequiredAuthError ||
        error instanceof Msal.BrowserAuthError
      ) {
        return await AuthService.msalInstance.logoutRedirect();
      }
    });
  }

  public static getAccounts(): Msal.AccountInfo[] {
    return AuthService.msalInstance.getAllAccounts();
  }

  public static getAccount(): Msal.AccountInfo | null {
    return AuthService.msalInstance.getActiveAccount();
  }

  public static getMsal(): Msal.PublicClientApplication {
    return AuthService.msalInstance;
  }

  public static getUser(): Observable<{ user: UserHeader }> {
    return window.axios.get(`/auth`).pipe(mapToData());
  }
}
